export {SearchResultItemConnected as SearchResultItem} from './SearchResultItem.connect';
